(function(app) {

    app.filter("replace",
        function() {
            return function (input, searchValue, newValue) {
                var test = new RegExp(searchValue, "g");
                return input.replace(test, newValue).trim();
            }
        });

})(window.app); //jshint ignore:line